module.exports = __webpack_public_path__ + "static/q7answer3_homecinema_wishmas-c79097ea3c25d6bd8adc3fefbab6b957.jpg";